const AdminMenus = [
    {
        id: 1,
        name: 'Home',
        links: '/admin',
    },
    {
        id: 2,
        name: 'Items',
        links: '/admin/items',
    },
    {
        id: 3,
        name: 'Steam Logs',
        links: '/admin/steam-logs',
    },
    {
        id: 4,
        name: 'Rates',
        links: '/admin/rates',
    },
    {
        id: 5,
        name: 'Transactions',
        links: '/admin/transactions',
    },
    {
        id: 6,
        name: 'Users',
        links: '/admin/users',
    },
    {
        id: 7,
        name: 'Orders/Sale to Us',
        links: '/admin/orders',
    },
    // {
    //     id: 5,
    //     name: 'Page',
    //     links: '#',
    //     namesub: [
    //         {
    //             id: 1,
    //             sub: 'Authors 01',
    //             links: '/authors-01'
    //         },
    //         {
    //             id: 2,
    //             sub: 'Authors 02',
    //             links: '/authors-02'
    //         },
    //         {
    //             id: 3,
    //             sub: 'Wallet Connect',
    //             links: '/wallet-connect'
    //         },
    //         {
    //             id: 4,
    //             sub: 'Create Item',
    //             links: '/create-item'
    //         },
    //         {
    //             id: 5,
    //             sub: 'Edit Profile',
    //             links: '/edit-profile'
    //         },
    //         {
    //             id: 6,
    //             sub: 'Ranking',
    //             links: '/ranking'
    //         },
    //         {
    //             id: 7,
    //             sub: 'Login',
    //             links: '/login'
    //         },
    //         {
    //             id: 8,
    //             sub: 'Sign Up',
    //             links: '/sign-up'
    //         },
    //         {
    //             id: 9,
    //             sub: 'No Result',
    //             links: '/no-result'
    //         },
    //         {
    //             id: 10,
    //             sub: 'FAQ',
    //             links: '/faq'
    //         }
    //     ],
    // },
    // {
    //     id: 7,
    //     name: 'Contact',
    //     links: '/contact-01',
    //     namesub: [
    //         {
    //             id: 1,
    //             sub: 'Contact 1',
    //             links: '/contact-01'
    //         },
    //         {
    //             id: 2,
    //             sub: 'Contact 2',
    //             links: '/contact-02'
    //         }
    //     ],
    // },

]

export default AdminMenus;
